(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/form.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/form.js'); 'use strict';

if (svs.core.detect.formfactor.desktop() === false) {
  $(document).ready(function() {
    var fixedElementSelector = '.header';

    if (svs.core.detect.os.android()) {
      fixedElementSelector =
        '.header, .js-overlay-container, .js-modal-container';
    }

    $('body').on(
      {
        focus: function(e) {
          if (isTogglingKeyboard(e.target)) {
            $(fixedElementSelector).addClass('absolute');
          }
        },
        focusout: function(e) {
          if (isTogglingKeyboard(e.target)) {
            $(fixedElementSelector).removeClass('absolute');
          }
        }
      },
      'input, textarea'
    );
  });
}

function isTogglingKeyboard(el) {
  if (el && el.type && el.type === 'radio') {
    return false;
  }

  return true;
}

 })(window);